<template>
  <jumbotron>

    <div v-if="!finished">
      <div class="info-message">
        <span>Enter Your Email Address</span>
      </div>

      <form class="mt-4">
        <div class="form-group">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="E-mail"
              v-model="email"
              :disabled="sendingEmail"
                  @keyup.enter="sendRecoveryEmail"/>
            <div class="input-group-append">
              <span class="input-group-text"><i class="fas fa-user fa-fw"/></span>
            </div>
          </div>
        </div>
        <!-- password field present but not modeled or shown, which triggers form to prefill it. -->
        <input type="password" class="form-control" placeholder="Password"
              v-show="false"
              :disabled="sendingEmail"/>
      </form>

      <div class="mt-3 text-muted">
        We'll send a message with instructions to help you reset your password.<br>
      </div>

      <div class="mt-3 text-right">
        <button class="btn btn-outline-secondary" :disabled="sendingEmail"
            @click="$router.push({name: 'login'})">
          <i class="fa fa-times"/>
          Cancel
        </button>
        <button class="btn btn-outline-primary" :disabled="!email || sendingEmail"
            @click="sendRecoveryEmail">
          <i class="fa fa-fw" :class="[ sendIcon ]"/>
          Send{{ sendingEmail ? 'ing' : '' }} Email
        </button>
      </div>
    </div>

    <div v-if="finished">
      <div class="info-message">
        Request Received
      </div>
      <div class="mt-3">
        If your email address is enrolled, then we've sent a message to
        help you regain access to your account. If you do not receive the
        message within several minutes, please check your spam
        folder and try again.
      </div>
      <div class="mt-2 text-right">
        <button class="btn btn-outline-primary" @click="$router.push({path: '/login'})">
          <i class="fa fa-times"/>
          Return to Login
        </button>
      </div>
    </div>

  </jumbotron>
</template>

<script>
import exceptionHandler from '@/common/exception-handler'
import userInfoMixin from '@/common/mixins/user-info-mixin'
import exceptionMixin from '@/common/mixins/exception-mixin'
import jumbotron from '@/common/elements/Jumbotron'

export default {
  name: 'Recover',
  mixins: [ userInfoMixin, exceptionMixin ],
  components: { jumbotron },
  data () {
    return {
      email: '',
      sendingEmail: false,
      sendRecoveryErrors: [],
      finished: false
    }
  },
  computed: {
    sendIcon () { return this.sendingEmail ? 'fa-sync-alt fa-spin' : 'fa-paper-plane' }
  },
  methods: {
    async sendRecoveryEmail () {
      if (!this.email || this.email.length < 5) {
        return
      }
      this.sendingEmail = true
      try {
        await this.$store.dispatch('login/sendPasswordReset', this.email)
        this.finished = true
      } catch (error) {
        if (exceptionHandler.isUserError(error)) {
          this.sendRecoveryErrors = error
        } else {
          this.handleError(error, 'Unable to process your request, please try again later.')
        }
      } finally {
        this.sendingEmail = false
      }
    }
  }
}
</script>
